/* eslint-disable import/prefer-default-export */
import { isMobileSelector } from 'reduxModules/app/selectors'

// selectors
const contestSelector = (state) => state.contests.detail
const statusSelector = (state) => state.contests.status
const usedFreeTrialSelector = (state) => state.auth.usedFreeTrial
const subscriptionSelector = (state) => state.auth.subscription

// states (mapStateToProps)
export const contestStateSelector = (state) => ({
  ...contestSelector(state),
  status: statusSelector(state),
  isMobile: isMobileSelector(state),
  usedFreeTrial: usedFreeTrialSelector(state),
  subscription: subscriptionSelector(state)
})
